import { Seo } from '@/components/site/seo';
import { ServicesSection } from '@/components/site/sections/services';
import { BannerHero } from '@/components/site/banner-hero';
import { listServices } from '@/lib/data/public';
import { useLiveData } from '~/hooks/useLiveData';
import { useLocaleContext } from '~/hooks/useLocaleContext';

export default function AreasPage() {
  const { locale, dict } = useLocaleContext();
  const services = useLiveData(listServices, [locale]).data ?? [];

  return (
    <>
      <Seo
        locale={locale}
        title={dict.services.title}
        description={dict.services.subtitle}
        path="/areas"
        image="/banners/banner-web-4.jpg"
      />
      <BannerHero image="/banners/banner-web-4.jpg" title={dict.services.title} />
      <ServicesSection locale={locale} dict={dict} services={services} compact />
    </>
  );
}
